const levenshtein = require("js-levenshtein");

export function levenshteinGrade(code, answer, html) {
    const bugs = levenshtein(code, answer);
    const grade = (bugs - levenshtein(html, answer)) / bugs;
    if (grade < 0) {
        grade = 0;
    }
    return grade;
}